export const typeObjectFieldName = 'tipoobjecto';
export const typeEntityFieldName = 'tipoentidade';
export const entityIdFieldName = 'identidade';
export const entityNameFieldName = 'nomeentidade';

export const editableFieldName = 'editavel';

export const searchResultsFieldAliasMap = new Map<string, string>([
  ['identidade', 'Entidade'],
]);
